import { render } from "./VisualIdentitySystemsView.vue?vue&type=template&id=eafa0ae0&scoped=true"
import script from "./VisualIdentitySystemsView.vue?vue&type=script&lang=js"
export * from "./VisualIdentitySystemsView.vue?vue&type=script&lang=js"

import "./VisualIdentitySystemsView.vue?vue&type=style&index=0&id=eafa0ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eafa0ae0"]])

export default __exports__